import { render, staticRenderFns } from "./rsOnboardingPage.vue?vue&type=template&id=df87494a&scoped=true"
import script from "./rsOnboardingPage.vue?vue&type=script&lang=js"
export * from "./rsOnboardingPage.vue?vue&type=script&lang=js"
import style0 from "./rsOnboardingPage.vue?vue&type=style&index=0&id=df87494a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df87494a",
  null
  
)

export default component.exports